import { useState } from 'react'
import { SelectionMenuProps } from '~/components/Selections/SelectionMenu/type'

type UseActiveOptionProps = {
  value: string
  isOpen: boolean
  options: SelectionMenuProps['options']
  collapseSelected: boolean
}

export default function useActiveOption({
  value,
  isOpen,
  options,
  collapseSelected
}: UseActiveOptionProps) {
  const [activeOptionIndex, setActiveOptionIndex] = useState(-1)
  const clearActiveOption = () =>
    activeOptionIndex !== -1 && setActiveOptionIndex(-1)

  if (!isOpen) {
    clearActiveOption()
  }

  const [previousValue, setPreviousValue] = useState(value)

  if (value !== previousValue) {
    clearActiveOption()
    setPreviousValue(value)
  }

  const [previousCollapseSelected, setPreviousCollapseSelected] =
    useState(collapseSelected)

  const [previousOptionsLength, setPreviousOptionsLength] = useState(
    options.length
  )

  // when options are selected, hidden or revealed, we try to keep same or nearest active option
  if (previousOptionsLength !== options.length) {
    if (previousCollapseSelected === collapseSelected) {
      const optionsDifference = options.length - previousOptionsLength
      setActiveOptionIndex((previousIndex) =>
        previousIndex < 0
          ? -1
          : Math.max(
              Math.min(options.length - 1, previousIndex + optionsDifference),
              0
            )
      )
    }

    setPreviousOptionsLength(options.length)
  }

  if (previousCollapseSelected !== collapseSelected) {
    setPreviousCollapseSelected(collapseSelected)
  }

  return {
    activeOptionIndex,
    activeOptionId: options[activeOptionIndex]?.id || '',
    setPreviousActiveOption: () =>
      setActiveOptionIndex((previousIndex) =>
        previousIndex > 0 ? previousIndex - 1 : options.length - 1
      ),
    setNextActiveOption: () =>
      setActiveOptionIndex((previousIndex) =>
        previousIndex < options.length - 1 ? previousIndex + 1 : 0
      ),
    clearActiveOption
  }
}
